<!-- 项目文件 -->
<template>
  <div>
    <div class="bgfff h50 lh50 textc pl16 pr16 bbe8">
        <div class="disinblock floatl" @click="openNav()">
          <img class="w16 h14" src="../../public/img/img4.png" alt="">
        </div>
        <div class="disinblock h100p lh50">
            <router-link to="/" tag="div" class="alit h100p">
              <img class="w100 h26 " src="../../public/img/img5.png" alt="">
            </router-link>
        </div>
        <!-- <div class="disinblock floatr">
          <div class=" h100p" @click="open()" v-if="isSchool==1">
            <span class=" fs12 c333  pl5 pr5 pt5 pb5 border1f8 bradius25">申请入驻</span>
          </div>
        </div> -->
    </div>
    <div class="posfix top50 isw0 h100p bg333 zindex9999"  :class="{isw100p:isOpen == 1}" >
      <div class=" disblock isopa0" :class="{isopa1:isOpen == 1}">
       
        <van-collapse v-model="activeName" accordion :border="false">
          <router-link to="/">
            <dt class="fs16 cfff pt16 pb10 pl16 pr16 ">回到首页</dt>
          </router-link>
          <van-collapse-item title="我是驾校" name="1" >
            <dl class="pl16 pr16 ">
              
              <router-link to="/School/Index">
                <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">驾校服务</dt>
              </router-link>
              <router-link to="/School/Smallapp">
                <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">驾校招生小程序</dt>
              </router-link>
              <router-link to="/School/Schoolmanage">
                <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">驾校培训系统</dt>
              </router-link>
              <router-link to="/School/Wemedia">
                <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">自媒体运营</dt>
              </router-link>
              <router-link to="/School/Cmedia">
                <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">融媒体推广</dt>
              </router-link>
             

            </dl>
          </van-collapse-item>
          <van-collapse-item title="我是学员" name="2">
              <dl class="pl16 pr16 ">
                <a href="https://m.yixueyijia.com/school_wap/wap/html/index.html">
                  <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">驾校列表</dt>
                </a>
                <a href="https://m.yixueyijia.com/school_wap/wap/html/school/helpschool.html">
                  <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">选驾校</dt>
                </a>
                <a href="https://m.yixueyijia.com/school_wap/wap/html/frame.html?dh=bmlc">
                  <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">报名流程</dt>
                </a>
                <a href="https://m.yixueyijia.com/school_wap/wap/html/frame.html?dh=xclc">
                  <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">学车流程</dt>
                </a>
                <a href="https://m.yixueyijia.com/school_wap/wap/html/frame.html?dh=fwbz">
                  <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">服务保障</dt>
                </a>
                <a href="https://m.yixueyijia.com/school_wap/wap/html/xc/studycar.html">
                  <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">模拟考试</dt>
                </a>
                <!-- <a href="https://m.yixueyijia.com/school_wap/wap/login.html?jump=html/yueke/yuyue.html">
                  <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">在线约考</dt>
                </a> -->
                <a href="https://m.yixueyijia.com/school_wap/wap/login.html?jump=html/yueke/yuyue.html">
                  <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">在线约课</dt>
                </a>
                <a href="https://m.yixueyijia.com/school_wap/wap/html/adress.html">
                  <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">发现</dt>
                </a>
                <a href="https://m.yixueyijia.com/school_wap/wap/html/frame.html?dh=cjwt">
                  <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">常见问题</dt>
                </a>

              </dl>
          </van-collapse-item>
          <van-collapse-item title="我是合作伙伴" name="4">
            <dl class="pl16 pr16 ">
              <router-link to="/Partner/index">
                <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">合作加盟</dt>
              </router-link>
            </dl>
          </van-collapse-item>
          <van-collapse-item title="关于我们" name="5">
            <dl class="pl16 pr16 ">
              <router-link to="/About/Index">
                <dt class="fs14 cfff pt8 pb8" @click="Toswitch()">关于我们</dt>
              </router-link>
            </dl>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
 
  </div>
</template>

<script>
    import $ from "jquery";
    export default {
        props: [],
        data() {
            return {
                isOpen: 0,
                activeName: ['0'],

            };
        },
        methods: {
            openNav() {
                if (this.isOpen == 0) {
                    $('body').css("overflow", "hidden");
                    this.isOpen = 1;
                } else {
                    this.isOpen = 0;
                    $('body').css("overflow", "auto");
                }
            },

            Toswitch() {
                this.isOpen = 0;
                $('body').css("overflow", "auto");
            }
        },
        created() {
            $('body').css("overflow", "auto");
        },
        mounted() {

        },
    }
</script>
<style scoped>
    .isw0 {
        transition: width 0.3s;
        width: 0;
    }
    
    .isw100p {
        transition: width 0.3s;
        width: 100%;
    }
    
    .isopa0 {
        opacity: 0;
    }
    
    .isopa1 {
        opacity: 1;
        transition: opacity 0.3s,
    }
    
    /deep/.van-cell,
    /deep/.van-collapse-item__content {
        background-color: #333;
        color: #fff;
    }
    
    /deep/.van-collapse-item {
        border-bottom: 1px solid #666;
    }
    
    /deep/.van-collapse-item__content {
        padding-top: 0;
    }
    
    /deep/.van-cell::after,
    /deep/.van-collapse-item--border::after {
        border-bottom: none;
        border-top: none
    }
    
    /deep/.van-cell__title span {
        color: #fff;
        font-size: 16px;
    }
</style>